module.exports = __webpack_public_path__ + "static/media/icon-mastercard.4d884409.svg";